import {
	UndefinedInitialDataInfiniteOptions,
	infiniteQueryOptions
} from '@tanstack/react-query'

import { SearchOffersDto } from '@wwt/entities/api/search-response'
import { OffersAndMetadata } from '@wwt/entities/search-response'

import * as Errors from '@/shared/lib/errors'

import {
	SEARCH_ERROR_DELAY,
	SEARCH_WAIT_ERROR_DELAY
} from '../config/searchDelays.ts'
import { searchKeys } from '../config/searchQueryKeys.ts'
import { searchQuery } from '../query/searchQuery.ts'

export const searchOptions = (
	searchRequest: SearchOffersDto,
	otherParams: Partial<
		Omit<
			UndefinedInitialDataInfiniteOptions<OffersAndMetadata>,
			'queryKey' | 'queryFn'
		>
	>
) => {
	return infiniteQueryOptions<OffersAndMetadata>({
		queryKey: searchKeys.get(searchRequest),
		queryFn: ({ pageParam, signal }) =>
			searchQuery(searchRequest, pageParam as number, signal),
		initialPageParam: 0,
		getNextPageParam: lastPage => {
			const newCursor = lastPage.metadata.page + lastPage.metadata.sizePage

			if (lastPage.metadata.totalElements <= newCursor) {
				return null
			}

			return newCursor
		},

		retry: (_, error) => {
			if (error instanceof Errors.SearchWaitError) {
				return true
			}

			return false
		},

		retryDelay: (_, error) => {
			if (error instanceof Errors.SearchWaitError) {
				return SEARCH_WAIT_ERROR_DELAY
			}

			return SEARCH_ERROR_DELAY
		},

		refetchOnMount: false,
		refetchOnReconnect: false,
		refetchOnWindowFocus: false,
		...otherParams
	})
}
